
import { defineComponent, PropType } from 'vue'
import { DateRangeOptionT } from '~/utils/date'

export default defineComponent({
  name: 'DateRangePicker',
  model: {
    prop: 'selectedFilter',
    event: 'change'
  },
  props: {
    selectedFilter: {
      type: String,
      default: ''
    },
    dateRangeOptions: {
      type: Object as PropType<Record<string, DateRangeOptionT>>,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.selectedFilter
      },
      set(value: string) {
        this.$emit('change', value)
      }
    }
  }
})
